<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication" id="ch00_fm04_dedi"><a id="page_v"></a><em>For Peter D. Kairoff<br/>Elizabeth T. and David J. Butler<br/>Robyn L. and John J. Thomas III<br/>and<br/>Holly D. Thomas</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_dedi.vue?7a376a5a